// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.panel-YHWpv0 {
  display: grid;
  gap: 0.75rem;
  border-radius: 18px;
  padding: 1.25rem;
  background: linear-gradient(140deg, #111827 0%, #1f2937 55%, #111827 100%);
  color: #f8fafc;
  box-shadow: 0 16px 32px rgba(15, 23, 42, 0.35);
  border: 1px solid rgba(251, 191, 36, 0.35);
}

.title-SLtGTC {
  margin: 0;
  font-size: 1.05rem;
  letter-spacing: 0.02em;
  color: #fbbf24;
}

.copy-iQ0sOn {
  margin: 0;
  color: rgba(248, 250, 252, 0.8);
}

.badge-opRW4u {
  justify-self: start;
  border-radius: 999px;
  padding: 0.15rem 0.6rem;
  background: rgba(251, 191, 36, 0.2);
  color: #fbbf24;
  font-size: 0.75rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
`, "",{"version":3,"sources":["webpack://./src/components/shared_bridge_panel.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,0EAA0E;EAC1E,cAAc;EACd,8CAA8C;EAC9C,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,mCAAmC;EACnC,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B","sourcesContent":[".panel {\n  display: grid;\n  gap: 0.75rem;\n  border-radius: 18px;\n  padding: 1.25rem;\n  background: linear-gradient(140deg, #111827 0%, #1f2937 55%, #111827 100%);\n  color: #f8fafc;\n  box-shadow: 0 16px 32px rgba(15, 23, 42, 0.35);\n  border: 1px solid rgba(251, 191, 36, 0.35);\n}\n\n.title {\n  margin: 0;\n  font-size: 1.05rem;\n  letter-spacing: 0.02em;\n  color: #fbbf24;\n}\n\n.copy {\n  margin: 0;\n  color: rgba(248, 250, 252, 0.8);\n}\n\n.badge {\n  justify-self: start;\n  border-radius: 999px;\n  padding: 0.15rem 0.6rem;\n  background: rgba(251, 191, 36, 0.2);\n  color: #fbbf24;\n  font-size: 0.75rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n"],"sourceRoot":""}]);
// Exports
export var panel = `panel-YHWpv0`;
export var title = `title-SLtGTC`;
export var copy = `copy-iQ0sOn`;
export var badge = `badge-opRW4u`;
export default ___CSS_LOADER_EXPORT___.toString();
